import React, { useEffect, useState } from "react";

const Imagesection = ({ datalist }) => {
  const [selectedimage, setSeleectedimage] = useState();
  const [position, setPosition] = useState(1);

  console.log("console.log image", datalist);
  return (
    <div className="w-full">
      <div className="w-full aspect-square rounded-5xl">
        <img
          src={selectedimage || datalist?.image_1?.location}
          className="w-full h-full object-cover rounded-5xl"
          alt="img"
        />
      </div>
      <div className="px-4 mt-2 flex gap-3">
        {datalist?.image_1?.location && (
          <div
            className={`w-24 h-24 bg-white ${
              position == 1 ? "border-4 border-textColor" : ""
            }  rounded-xl cursor-pointer`}
            onClick={() => {
              setSeleectedimage(datalist?.image_1?.location);
              setPosition(1);
            }}
          >
            <img
              src={datalist?.image_1?.location}
              className="w-full h-full object-cover rounded-xl"
              alt="img"
            />
          </div>
        )}

        {datalist?.image_2?.location && (
          <div
            className={`w-24 h-24 bg-white ${
              position == 2 ? "border-4 border-textColor" : ""
            }  rounded-xl cursor-pointer`}
            onClick={() => {
              setSeleectedimage(datalist?.image_2?.location);
              setPosition(2);
            }}
          >
            <img
              src={datalist?.image_2?.location}
              className="w-full h-full object-cover rounded-xl"
            />
          </div>
        )}
        {datalist?.image_3?.location && (
          <div
            className={`w-24 h-24 bg-white ${
              position == 3 ? "border-4 border-textColor" : ""
            }  rounded-xl cursor-pointer`}
            onClick={() => {
              setSeleectedimage(datalist?.image_3?.location);
              setPosition(3);
            }}
          >
            <img
              src={datalist?.image_3?.location}
              className="w-full h-full object-cover rounded-xl"
            />
          </div>
        )}
        {datalist?.image_4?.location && (
          <div
            className={`w-24 h-24 bg-white ${
              position == 4 ? "border-4 border-textColor" : ""
            }  rounded-xl cursor-pointer`}
            onClick={() => {
              setSeleectedimage(datalist?.image_4?.location);
              setPosition(4);
            }}
          >
            <img
              src={datalist?.image_4?.location}
              className="w-full h-full object-cover rounded-xl"
              alt="img"
            />
          </div>
        )}
        {datalist?.image_5?.location && (
          <div
            className={`w-24 h-24 bg-white ${
              position == 5 ? "border-4 border-textColor" : ""
            }  rounded-xl cursor-pointer`}
            onClick={() => {
              setSeleectedimage(datalist?.image_5?.location);
              setPosition(5);
            }}
          >
            <img
              src={datalist?.image_5?.location}
              className="w-full h-full object-cover rounded-xl"
              alt="img"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Imagesection;
